import html2pdf from "html2pdf.js";

export const exportToPdf = async ({ html, fileName }) => {
  const container = document.createElement("div");
  container.innerHTML = html;
  document.body.appendChild(container);

  try {
    await html2pdf()
      .from(container)
      .set({
        margin: [5, 5, 5, 5],
        filename: fileName,
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      })
      .save();

    console.log("PDF berhasil diunduh");
  } catch (error) {
    console.error("Terjadi kesalahan saat mengunduh PDF:", error);
    throw error;
  } finally {
    if (document.body.contains(container)) {
      document.body.removeChild(container);
    }
  }
};